import { SalesOrderTabs } from "./_models/tabdata/sales/salesorder-tabs";
export default [
  // Home
  {
    text: "Home",
    path: "/home",
    icon: "fa-solid fa-house icon-20",
  },
  {
    text: "Create New",
    icon: "fa-solid fa-plus icon-20",
    type: "Global",
    items: [
      {
        text: "Customer",
        type: "Screen",
        applicationFeatureCode: "Customer",
        path: "/customer/create",
      },
      {
        text: "Supplier",
        type: "Screen",
        applicationFeatureCode: "Supplier",
        path: "/supplier/create",
      },
      {
        text: "Product",
        type: "Screen",
        applicationFeatureCode: "Product",
        path: "/product/create",
      },
      {
        text: "Sales Order",
        type: "Screen",
        applicationFeatureCode: "SalesOrder",
        path: "/sales-order/create",
      },
      {
        text: "Purchase Order",
        type: "Screen",
        applicationFeatureCode: "PurchaseOrder",
        path: "/purchase-order/create",
      },
      {
        text: "Customer Invoice",
        type: "Screen",
        applicationFeatureCode: "Invoice",
        path: "/invoice/create",
      },
      {
        text: "Customer Credit",
        type: "Screen",
        applicationFeatureCode: "Invoice",
        path: "/credit-customer/create",
      },
      {
        text: "Customer Receipt",
        type: "Screen",
        applicationFeatureCode: "CashReceipt",
        path: "/customer-receipt/create",
      },
      {
        text: "Supplier Invoice",
        type: "Screen",
        applicationFeatureCode: "SupplierInvoice",
        path: "/supplier-invoice/create",
      },
      {
        text: "Supplier Payment",
        type: "Screen",
        applicationFeatureCode: "CashPayment",
        path: "/supplier-payment/create",
      },
      {
        text: "Journal",
        type: "Screen",
        applicationFeatureCode: "Journals",
        path: "/journals/create",
      },
    ],
  },
  {
    text: "Finance",
    icon: "fa-solid fa-building-columns icon-20",
    type: "Work Centre",
    applicationFeatureCode: "FinanceWorkCentre",
    items: [
      {
        text: "Journals",
        type: "Screen",
        applicationFeatureCode: "Journals",
        path: "/journals",
      },
      {
        text: "GL Accounts",
        type: "Screen",
        applicationFeatureCode: "GlAccounts",
        path: "/gl-accounts",
      },
      {
        text: "Bank Accounts",
        type: "Screen",
        applicationFeatureCode: "BankAccounts",
        path: "/bank-accounts",
      },
    ],
  },
  // Reports
  {
    text: "Reports",
    icon: "fa-solid fa-file-invoice icon-20",
    type: "Screen",
    path: "/reports",
    applicationFeatureCode: "ReportsWorkCentre",
  },
  // Call Schedules
  {
    text: "Call Schedule",
    icon: "fa-solid fa-calendar-alt icon-20",
    type: "Screen",
    applicationFeatureCode: "CallSchedules",
    path: "/call-schedule",
  },
  // Customers
  {
    text: "Customers",
    icon: "fa-solid fa-people-group icon-20",
    type: "Screen",
    applicationFeatureCode: "Customer",
    path: "/customer",
  },
  // Suppliers
  {
    text: "Suppliers",
    icon: "fa-solid fa-cart-flatbed icon-20",
    type: "Screen",
    applicationFeatureCode: "Supplier",
    path: "/supplier",
  },
  // Products
  {
    text: "Products",
    icon: "fa-solid fa-box-open icon-20",
    type: "Screen",
    path: "/product",
    applicationFeatureCode: "Product",
  },
  // Sales
  {
    text: "Sales",
    icon: "fa-solid fa-dollar-sign icon-20",
    type: "Work Centre",
    applicationFeatureCode: "SalesWorkCentre",
    items: [
      {
        text: "Orders",
        type: "Screen",
        // Matches on either SalesOrder or OrderPicking (Despatch Order) so a Despatch-only
        // role still sees the "Orders" menu item, showing only the tabs it has access to
        // (tab-level gating in salesorder-tabs.js already filters correctly). Bug 75841.
        applicationFeatureCode: SalesOrderTabs.map((x) => x.applicationFeatureCode),
        path: "/sales-order",
        subType: "TabbedScreen",
        tabs: SalesOrderTabs,
      },
      {
        text: "Contracts",
        type: "Screen",
        applicationFeatureCode: "CustomerSalesContract",
        path: "/sales-contract",
      },
      {
        text: "Pricing",
        type: "Screen",
        applicationFeatureCode: "PriceGroup",
        path: "/price-group",
      },
      {
        text: "Sample Requests",
        type: "Screen",
        applicationFeatureCode: "SampleRequests",
        path: "/sample-request",
      },
      {
        text: "Point of Sale",
        type: "Screen",
        applicationFeatureCode: "PointOfSale",
        path: "/point-of-sale/create",
      },
      {
        text: "Distribution Manifest",
        type: "Screen",
        applicationFeatureCode: "DistributionManifest",
        path: "/distribution-manifest",
      }
    ],
  },
  // Purchasing
  {
    text: "Purchasing",
    icon: "fa-solid fa-cart-shopping icon-20",
    type: "Work Centre",
    applicationFeatureCode: "InventoryWorkCentre",
    items: [
      {
        text: "Orders",
        type: "Screen",
        applicationFeatureCode: "PurchaseOrder",
        path: "/purchase-order",
      },
      {
        text: "Planning",
        type: "Screen",
        applicationFeatureCode: "PurchasePlanning",
        path: "/purchase-planning/create",
      },
      {
        text: "Intake Estimate",
        type: "Screen",
        applicationFeatureCode: "AlmondcoIntakeEstimate",
        path: "/intake-estimate",
      },
    ],
  },
  // Demand Planning
  {
    text: "Demand Planning",
    icon: `fa-solid fa-magnifying-glass-chart icon-20`,
    type: "Work Centre",
    applicationFeatureCode: "DemandPlanningWorkCentre",
    items: [
      {
        text: "MRP",
        type: "Screen",
        applicationFeatureCode: "MRP",
        path: "/mrp",
      },
      {
        text: "Crop Tracker",
        type: "Screen",
        applicationFeatureCode: "CropTracker",
        path: "/crop-tracker",
      },
    ],
  },

  // Production
  {
    text: "Production",
    icon: "fa-solid fa-industry icon-20",
    type: "Work Centre",
    applicationFeatureCode: "ProductionWorkCentre",
    items: [
      {
        text: "BOMs",
        type: "Screen",
        applicationFeatureCode: "BillOfMaterial",
        path: "/bill-of-materials",
      },
      {
        text: "Process Capacity",
        type: "Screen",
        applicationFeatureCode: "ProcessCapacity",
        path: "/process-capacity",
      },
      {
        text: "Planning",
        type: "Screen",
        applicationFeatureCode: "ProductionPlanning",
        path: "/production-planning",
      },
      {
        text: "Work Orders",
        type: "Screen",
        applicationFeatureCode: "WorkOrder",
        path: "/work-order",
      },
      {
        text: "Maintenance Orders",
        type: "Screen",
        applicationFeatureCode: "MaintenanceOrder",
        path: "/maintenance-order",
      },
      {
        text: "Schedule",
        type: "Screen",
        applicationFeatureCode: "ProductionSchedule",
        path: "/production-calendar",
      },
      {
        text: "Timesheet",
        type: "Screen",
        applicationFeatureCode: "Timesheet",
        path: "/timesheet",
      },
    ],
  },
  // Inventory
  {
    text: "Inventory",
    icon: "fa-solid fa-warehouse icon-20",
    type: "Work Centre",
    applicationFeatureCode: "InventoryWorkCentre",
    items: [
      {
        text: "Stock Adjustment",
        type: "Screen",
        applicationFeatureCode: "StockAdjustment",
        path: "/stock-adjustment",
      },
      {
        text: "Stock Transfer",
        type: "Screen",
        applicationFeatureCode: "StockTransfer",
        path: "/stock-transfer",
      },
      {
        text: "Stocktake",
        type: "Screen",
        applicationFeatureCode: "StocktakeCount",
        path: "/stocktake",
      },
      {
        text: "Bins",
        type: "Screen",
        applicationFeatureCode: "IntakeBins",
        path: "/bin-list",
      },
      {
        text: "Inshell",
        type: "Screen",
        applicationFeatureCode: "Inshell",
        path: "/almondco-inshell",
      },
      {
        text: "Cracking Run",
        type: "Screen",
        applicationFeatureCode: "CrackingRunGrowerReady",
        path: "/grower-ready",
      },
      // {
      //   text: "MRP",
      //   type: "Screen",
      //   applicationFeatureCode: "MRP",
      //   path: "/mrp",
      // },
    ],
  },
  {
    text: "Quality Control",
    icon: "fa-solid fa-flask icon-20",
    type: "Work Centre",
    applicationFeatureCode: "QualityControlWorkCentre",
    items: [
      {
        text: "Customer Complaints",
        type: "Screen",
        applicationFeatureCode: "CustomerComplaints",
        path: "/customer-complaints",
      },
    ],
  },
  {
    text: "Settings",
    icon: "fa-solid fa-gears icon-20",
    type: "Work Centre",
    applicationFeatureCode: "SettingsWorkCentre",
    path: "/settings",
  },
];
